import React from 'react'
import { IBackgroundJobService$IJobState, IScriptedExactOnlineConfiguration } from 'interfaces';
import { Registry } from '.';
import { sleep } from 'component_utils/utils';
import { addNotification } from 'utils/NotificationManager';
import Translation from 'utils/Language/Translation';

export interface ExactOnlineTopicConfigurationDto { userConfig: string; defaultConfig: string; }

export default ({ get, post, destroy }: Registry) => {
  return {
    exactOnline: {
      downloadBrowserExtension: (): Promise<any> => get('/api/v1/exact_online_extension/latest_extension_bundle'),
      users: () => get<{ FullName: string, EndDate: string }[]>('/api/v1/exact_online_extension/system_users'),
      syncUsers: () => post('/api/v1/exact_online_extension/system_users_sync', {}),
      glAccounts: () => get<{ ID: string, Code: string, Description: string }[]>('/api/v1/exact_online_extension/gl_accounts'),
      syncGlAccounts: () => post('/api/v1/exact_online_extension/gl_accounts_sync', {}),
      browserExtensionConfig: {
        scripting: {
          getAll: (): Promise<{ script: IScriptedExactOnlineConfiguration, loaded: boolean }[]> => get('/api/v1/exact_online_extension/config/scripts'),
          save: (script: IScriptedExactOnlineConfiguration) => post('/api/v1/exact_online_extension/config/scripts', script),
          delete: (id: number) => destroy(`/api/v1/exact_online_extension/config/scripts/${id}`),
        }
      },
      databaseMonitor: {
        getTopicConfiguration: () => get<ExactOnlineTopicConfigurationDto>('/api/v1/exact_online_database/topicConfiguration'),
        saveTopicConfiguration: (data: string) => post('/api/v1/exact_online_database/topicConfiguration', { data }),

        getCallStats: () => get<{ performed: number; allowed: number; }>('/api/v1/exact_online_database/calls'),
        getTopicMetaData: () => get<{ name: string; currentlyRunning: boolean; currentlyRunningType: string; mightRequireFullLoad: boolean; allowReFetchSince: boolean; localCount: boolean; }[]>('/api/v1/exact_online_database/topic_states'),
        performCountCheck: (topic: string) => post<{ eoCount:number; myCount:number; }>('/api/v1/exact_online_database/topic_states/count_check', { topic }),
        getExactOnlineCount: (topic: string) => post<{ eoCount:number; }>('/api/v1/exact_online_database/topic_states/exact_online_count', { topic }),
        performSync: async (topic: string) => {
          const res = await post<{ id: string }>('/api/v1/exact_online_database/topic_states/perform_sync', { topic })
          let state
          do {
            await sleep(500)
            state = await get<IBackgroundJobService$IJobState>(`/api/v1/background_jobs/${res.id}`)
          } while (state.status !== 'FINISHED');
          if (!state.finishedSuccessfully) {
            addNotification(
              'danger',
              'Error',
              <Translation name={state.error} params={state.errorArgs} />,
            );
          }
        },
        performFullSync: async (topic: string) => {
          const res = await post<{ id: string }>(`/api/v1/exact_online_database/topic_states/perform_full_sync`, { topic })
          let state
          do {
            await sleep(500)
            state = await get<IBackgroundJobService$IJobState>(`/api/v1/background_jobs/${res.id}`)
          } while (state.status !== 'FINISHED');
          if (!state.finishedSuccessfully) {
            addNotification(
              'danger',
              'Error',
              <Translation name={state.error} params={state.errorArgs} />,
            );
          }
        },
        performSyncSince: async (topic: string, since: string) => {
          const res = await post<{ id: string }>('/api/v1/exact_online_database/topic_states/perform_sync_since', { topic, since })
          let state
          do {
            await sleep(500)
            state = await get<IBackgroundJobService$IJobState>(`/api/v1/background_jobs/${res.id}`)
          } while (state.status !== 'FINISHED');
          if (!state.finishedSuccessfully) {
            addNotification(
              'danger',
              'Error',
              <Translation name={state.error} params={state.errorArgs} />,
            );
          }
        },
        performRecheckDeleted: (days: number) => post(`/api/v1/exact_online_database/topic_states/recheck_deleted/${days}`, {}),
        fetchMetadata: (topic: string) => post<{ result: string; }>('/api/v1/exact_online_database/topic_states/fetchMetaData', { topic }),
      }
    },
  };
};
